/** Compact relative time for activity feeds (e.g. "5m ago", "Yesterday"). */
export function formatRelativeTime(isoOrMs: string | number): string {
  const d = typeof isoOrMs === 'number' ? new Date(isoOrMs) : new Date(isoOrMs)
  const ts = d.getTime()
  if (Number.isNaN(ts)) return ''

  const now = new Date()
  if (d.toDateString() === now.toDateString()) {
    const diffMs = Date.now() - ts
    const mins = Math.floor(diffMs / 60_000)
    if (mins < 1) return 'Just now'
    if (mins < 60) return `${mins}m ago`
    return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
  }

  const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000)
  if (d.toDateString() === yesterday.toDateString()) return 'Yesterday'

  const days = Math.floor((now.getTime() - ts) / (24 * 60 * 60 * 1000))
  if (days < 7) return `${days}d ago`

  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}
